var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGooglePlayNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7604 22.1016L37.9539 17.0156L25.8883 26.0307L37.9537 35.0458L46.7902 29.9423C48.168 29.1053 48.9902 27.6426 48.9902 26.0309C48.9902 24.4193 48.1679 22.9567 46.7604 22.1016Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9388 26.0302C28.9255 26.0472 18.2708 39.7461 18.2622 39.7572L4.38259 50.688C3.52836 49.8338 3.00989 48.6748 3.00989 47.3934V4.59127C3.00989 3.31018 3.52836 2.1509 4.38259 1.29688L18.2622 12.3031C18.2708 12.3142 28.9255 26.0132 28.9388 26.0302Z",
    fill: "#25D9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9388 26.0309L25.8883 29.9659V22.0957L28.9388 26.0309Z",
    fill: "#00C0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9682 17.0011L28.9387 26.0305L4.38257 1.29731C4.68751 1.02267 4.99266 0.809137 5.32821 0.595605C6.79233 -0.227916 8.53119 -0.197513 9.965 0.68722L25.8883 10.0461L37.9682 17.0011Z",
    fill: "#7FE881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9682 17.0018L28.9388 26.0313L25.8883 22.9808V10.0469L37.9682 17.0018Z",
    fill: "#5BC980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9682 35.0605L25.8883 42.0156L9.9345 51.3297C9.20239 51.7567 8.40927 52.0007 7.58555 52.0007C6.82293 52.0007 6.06032 51.7872 5.32821 51.3906C4.99266 51.1771 4.68751 50.9636 4.38257 50.6891L28.9387 26.0312L37.9682 35.0605Z",
    fill: "#FF637B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9682 35.0605L25.8883 42.0156V29.0817L28.9388 26.0312L37.9682 35.0605Z",
    fill: "#E63950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGooglePlayNew);
export default __webpack_public_path__ + "static/media/icon_google_play_new.b599fee8aa4858ae675ea9d379083235.svg";
export { ForwardRef as ReactComponent };